'use client';

import Icon from '@/components/ui/AppIcon';

export default function TrustBadges() {
  const badges = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Embassy Verified',
      description: 'Accepted worldwide'
    },
    {
      icon: 'BoltIcon',
      title: 'Instant Delivery',
      description: 'Within 5-30 minutes'
    },
    {
      icon: 'GlobeAltIcon',
      title: 'Active PNR',
      description: 'Real airline booking'
    },
    {
      icon: 'SparklesIcon',
      title: 'AI-Powered',
      description: 'Claude travel analysis'
    },
    {
      icon: 'CreditCardIcon',
      title: 'Secure Payment',
      description: 'Money-back guarantee'
    },
    {
      icon: 'ClockIcon',
      title: '24/7 Support',
      description: 'Always here to help'
    }
  ];

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl shadow-xl p-8 text-white">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-black mb-2">Trusted by 50,000+ Travelers</h2>
        <p className="text-blue-100">AI-powered onward tickets with instant embassy verification</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {badges?.map((badge, index) => (
          <div key={index} className="text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 rounded-lg mb-2">
              <Icon name={badge?.icon} size={24} className="text-white" />
            </div>
            <h3 className="font-bold text-sm mb-1">{badge?.title}</h3>
            <p className="text-xs text-blue-100">{badge?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}